<!--
    描述：订阅查看工具 --- 对比 --- 新增主要材料弹窗
    时间：2020-06-23
    Created by ws
-->
<template>
	<div class="w-page-main add-materials-main">
		<div class="w-page-header">
			<el-input placeholder="请输入材料名称"
					  @keyup.enter.native="doSearch"
					  v-model="currentName">
				<el-button slot="append"
						   class="search-btn"
						   @click="doSearch"
						   icon="el-icon-search"></el-button>
			</el-input>
		</div>

		<div class="w-page-container">
			<w-split v-model="split">
				<div slot="left"
					 class="h100 pdr5">
					<h3 class="title text-overflow">材料分类</h3>
					<el-tree :data="materialsTree"
							 :props="defaultProps"
							 ref="leftTree"
							 node-key="value"
							 @node-click="handleNodeClick"></el-tree>
				</div>

				<div slot="right"
					 class="w-table-layout pdl10 w-table-page">
					<div class="w-table-content">
						<el-table :data="tableObj.tableData"
								  highlight-current-row
								  v-loading="loading"
								  stripe
								  border
								  height="395">
							<el-table-column label="选择"
											 align="center"
											 width="70">
								<template slot-scope="scope">
									<el-checkbox v-model="scope.row.isChecked"></el-checkbox>
								</template>
							</el-table-column>
							<el-table-column label="材料编码"
											 align="center"
											 prop="code"
											 show-overflow-tooltip
											 min-width="100"></el-table-column>
							<el-table-column label="材料分类"
											 align="center"
											 prop="typeName"
											 show-overflow-tooltip
											 min-width="110"></el-table-column>
							<el-table-column label="名称"
											 show-overflow-tooltip
											 prop="sname"
											 header-align="center"
											 min-width="120"></el-table-column>
							<el-table-column label="规格 / 型号"
											 show-overflow-tooltip
											 prop="specification"
											 header-align="center"
											 min-width="100"></el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination @size-change="onSizeChange"
									   @current-change="onCurrentChange"
									   :current-page="tableObj.currentPage"
									   :page-sizes="tableObj.pageList"
									   :page-size="tableObj.pageSize"
									   layout="total, sizes, prev, pager, next, jumper"
									   :total="tableObj.total">
						</el-pagination>
					</div>
				</div>
			</w-split>
		</div>
	</div>
</template>

<script>
import {
	getMaterialCategorys,
	getPageConbinations,
	getPageMaterials,
	saveMainMaterials
} from '@/api/modules/resource.js'
import { mapState } from 'vuex'
export default {
	data() {
		return {
			split: 0.3,
			materialsTree: [
				{
					sname: '全部材料',
					value: '',
					resourceType: 1 // 1 代表材料  2代表组合
				}
			],
			// 树结构配置
			defaultProps: {
				children: 'children',
				label: 'sname'
			},
			currentName: '', // 当前材料名称
			currentType: '', // 当前材料分类
			isGroup: '',	// 是材料 还是组合
			tableObj: {
				tableData: [],
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},
			loading: false
		}
	},
	created() {
		// 获取左侧材料树
		this.getLeftTree()

		// this.doSearch()
	},
	mounted() {
		this.$nextTick(() => {
			this.$refs.leftTree.setCurrentNode(this.materialsTree[0])
		})
	},
	methods: {
		// 左侧材料节点 点击
		handleNodeClick(node, data) {
			this.currentType = node.value

			this.isGroup = parseFloat(node.resourceType)
			this.doSearch()
		},

		// 获取左侧材料 + 组合列表
		getLeftTree() {
			getMaterialCategorys({})
				.then(res => {
					this.materialsTree.push(...res.data)

					// 默认从第一个查询
					this.isGroup = 1	// 默认查全部材料
					this.doSearch()
				})
				.catch(err => {
					this.materialsTree = []
				})
		},

		// 查询函数
		doSearch() {
			this.loading = true
			this.tableObj.tableData = []

			// type === 1 是查材料 ， ===2  是查组合
			if (this.isGroup === 1) {
				// 调取接口
				getPageMaterials({
					sname: this.currentName,
					type: this.currentType,
					current: this.tableObj.currentPage,
					size: this.tableObj.pageSize
				})
					.then(res => {
						this.loading = false
						this.tableObj.tableData = res.data.records
						this.tableObj.total = parseInt(res.data.total)
					})
					.catch(err => {
						this.loading = false
					})
			} else {
				getPageConbinations({
					sname: this.currentName,
					current: this.tableObj.currentPage,
					size: this.tableObj.pageSize
				})
					.then(res => {
						this.loading = false
						this.tableObj.tableData = res.data.records
						this.tableObj.total = parseInt(res.data.total)
					})
					.catch(err => {
						this.loading = false
					})
			}
		},

		// 确定函数
		doSubmit() {
			// console.log(this.tableObj.tableData)
			let data = this.tableObj.tableData.filter(x => x.isChecked)

			let arr = []
			data.map(x => {
				arr.push(x.id)
			})
			saveMainMaterials({
				type: 1, // 1 是材料 2是人工
				resourceType: this.isGroup,
				resourceIds: arr
			})
				.then(res => {
					this.$emit('onSave', res.data)
				})
				.catch(err => {
					this.$emit('onSave')
				})
		},

		// 每页展示条数切换事件
		onSizeChange(val) {
			this.tableObj.pageSize = val
			this.doSearch()
		},

		// 当前页码 切换事件
		onCurrentChange(val) {
			this.tableObj.currentPage = val
			this.doSearch()
		}
	},
	computed: {
		...mapState('dict', {
			clfl: state => state.clfl
		})
	}
}
</script>

<style scoped lang="less">
.add-materials-main {
	.w-page-container {
		height: 440px;
	}
	.title {
		height: 32px;
		line-height: 32px;
		color: #303133;
		font-size: 16px;
	}
	.search-btn {
		color: #fff;
		background-color: #409eff;
		border-color: #409eff;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	.w-table-layout {
		background-color: #fff;
	}

	/deep/ .el-tree-node__content {
		height: 28px;
		line-height: 28px;
	}

	/deep/ .el-tree-node__content:hover {
		background-color: #039be5;
		color: #fff;
	}

	/deep/ .is-current {
		.el-tree-node__content {
			background-color: #039be5;
			color: #fff;
		}
	}
}
</style>
